import { render } from "./CompareTable.vue?vue&type=template&id=42320ac5&scoped=true&ts=true"
import script from "./CompareTable.vue?vue&type=script&lang=ts"
export * from "./CompareTable.vue?vue&type=script&lang=ts"

import "./CompareTable.vue?vue&type=style&index=0&id=42320ac5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42320ac5"]])

export default __exports__